import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmarkAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_397_29306",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_397_29306)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.5835 16.8748V4.42296C4.5835 4.00199 4.72933 3.64567 5.021 3.354C5.31266 3.06234 5.66898 2.9165 6.08995 2.9165H10.8335V4.1665H6.08995C6.02579 4.1665 5.96704 4.19324 5.9137 4.24671C5.86023 4.30005 5.8335 4.3588 5.8335 4.42296V14.9582L10.0002 13.1665L14.1668 14.9582V9.1665H15.4168V16.8748L10.0002 14.5511L4.5835 16.8748ZM14.1668 7.49984V5.83317H12.5002V4.58317H14.1668V2.9165H15.4168V4.58317H17.0835V5.83317H15.4168V7.49984H14.1668Z",
			fill: "currentColor"
		})
	})]
});
export default SvgBookmarkAdd;
